import { Permissions } from './config/AppEnums';

export const MENU_ITEMS: any[] = [
  //{
  //  title: 'E-commerce',
  //  icon: 'nb-e-commerce',
  //  link: '/pages/dashboard',
  //  home: true,
  //},
  //{
  //  title: 'IoT Dashboard',
  //  icon: 'nb-home',
  //  link: '/pages/iot-dashboard',
  //},
  //{
  //  title: 'FEATURES',
  //  group: true,
  //},
  //{
  //  title: 'Dashboard',
  //  icon: 'chart-pie',
  //  link: '/dashboard/index',
  //  permissions: [{ permissions: [{ permission: Permissions.DashboardModule }] }]
  //},
  {
    title: 'How it works',
    icon: 'info',
    link: 'secondaryUrl/tutorial',
  },
  {
    title: 'Dashboard',
    icon: 'chart-pie',
    link: 'secondaryUrl/dashboard/index',
    data: [Permissions.DashboardModule],

  },
  {
    groupName: 'IMS',
    icon: 'folder',
    data: [Permissions.ImsModule, Permissions.EMSView, Permissions.EMSManage],

    items: [
      {
        title: 'IMS',
        icon: 'folder',
        link: 'secondaryUrl/ims/index',
        data: [Permissions.ImsModule, Permissions.EMSView, Permissions.EMSManage],


      },
      {
        title: 'Reports',
        icon: 'cabinet-filing',
        link: '/app-reports/ims',
        data: [Permissions.ImsModule, Permissions.EMSReports],
      },
    ]
  },
  {
    groupName: 'Capex',
    icon: 'shopping-cart',
    data: [Permissions.CAPEX_Module, Permissions.CAPEX_CapexRequestor, Permissions.CAPEX_DisposalRequestor, Permissions.CAPEX_Admin,
    Permissions.CAPEX_CapexRequestor,
    Permissions.CAPEX_CEO,
    Permissions.CAPEX_FD,
    Permissions.CAPEX_FM,
    Permissions.CAPEX_MD,
    Permissions.CAPEX_Board,
    Permissions.CAPEX_ClosedOff,
    Permissions.CAPEX_OrderPlaced,
    Permissions.CAPEX_OrderReceived,
    Permissions.CAPEX_Shareholders,
    Permissions.CAPEX_DisposalRequestor,
    Permissions.CAPEX_DivisionReports,
    Permissions.CAPEX_GlobalReports,
    Permissions.CAPEX_Admin_Setup],
    hidden: true,
    items: [
      {
        title: 'Classifications',
        icon: 'cabinet-filing',
        link: '/capex/config',
        data: [Permissions.CAPEX_Admin, Permissions.CAPEX_Admin_Setup],
      },
      {
        title: 'Create Request',
        icon: 'plus',
        link: ['/', 'capex', 'requests', { id_1: '00000000-0000-0000-0000-000000000000' }],
        expanded: false,
        disableHighlight: true,
        data: [Permissions.CAPEX_CapexRequestor,
        Permissions.CAPEX_CEO,
        Permissions.CAPEX_FD,
        Permissions.CAPEX_FM,
        Permissions.CAPEX_MD,
        Permissions.CAPEX_Board,
        Permissions.CAPEX_ClosedOff,
        Permissions.CAPEX_OrderPlaced,
        Permissions.CAPEX_OrderReceived,
        Permissions.CAPEX_Shareholders],
      }, {
        title: 'Create Disposal',
        icon: 'plus',
        link: ['/', 'capex', 'requests', { id_2: '00000000-0000-0000-0000-000000000000' }],
        expanded: false,
        disableHighlight: true,
        data: [Permissions.CAPEX_DisposalRequestor,
        Permissions.CAPEX_CEO,
        Permissions.CAPEX_FD,
        Permissions.CAPEX_FM,
        Permissions.CAPEX_MD,
        Permissions.CAPEX_Board,
        Permissions.CAPEX_ClosedOff,
        Permissions.CAPEX_OrderPlaced,
        Permissions.CAPEX_OrderReceived,
        Permissions.CAPEX_Shareholders],
      }, {
        title: 'Create Transfer',
        icon: 'plus',
        link: ['/', 'capex', 'requests', { id_1: '00000000-0000-0000-0000-000000000000', _1_transferRequest: 1 }],
        expanded: false,
        disableHighlight: true,
        data: [Permissions.CAPEX_CapexRequestor,
        Permissions.CAPEX_CEO,
        Permissions.CAPEX_FD,
        Permissions.CAPEX_FM,
        Permissions.CAPEX_MD,
        Permissions.CAPEX_Board,
        Permissions.CAPEX_ClosedOff,
        Permissions.CAPEX_OrderPlaced,
        Permissions.CAPEX_OrderReceived,
        Permissions.CAPEX_Shareholders],
      },
      {
        title: 'Requests',
        icon: 'shopping-basket',
        link: '/capex/requests',
        data: [Permissions.CAPEX_CapexRequestor, Permissions.CAPEX_DisposalRequestor,
        Permissions.CAPEX_CEO,
        Permissions.CAPEX_FD,
        Permissions.CAPEX_FM,
        Permissions.CAPEX_MD,
        Permissions.CAPEX_Board,
        Permissions.CAPEX_ClosedOff,
        Permissions.CAPEX_OrderPlaced,
        Permissions.CAPEX_OrderReceived,
        Permissions.CAPEX_Shareholders],
      },
      {
        title: 'Divisions',
        icon: 'building',
        link: '/capex/divisions',
        data: [Permissions.CAPEX_Admin,
        Permissions.CAPEX_Admin_Setup],
      },
      {
        title: 'Setup',
        icon: 'cog',
        link: ['/', 'capex', 'divisions', { id_1: '00000000-0000-0000-0000-000000000000' }],
        data: [Permissions.CAPEX_Admin,
        Permissions.CAPEX_Admin_Setup],
        disableHighlight: true,
      },
      //{
      //  title: 'Budgets',
      //  icon: 'building',
      //  link: ['/', 'capex', 'info', { id_2: '00000000-0000-0000-0000-000000000000' }],
      //  data: [Permissions.CAPEX_Admin],
      //  disableHighlight: true,
      //},
      //{
      //  title: 'Closing Balances',
      //  icon: 'building',
      //  link: ['/', 'capex', 'info', { id_3: '00000000-0000-0000-0000-000000000000' }],
      //  data: [Permissions.CAPEX_Admin],
      //  disableHighlight: true,
      //},
      {
        title: 'Reports',
        icon: 'cabinet-filing',
        link: '/capex/reports',
        data: [Permissions.CAPEX_DivisionReports, Permissions.CAPEX_GlobalReports],
      },

    ]
  },
  {
    groupName: 'CRM and Job Tracking',
    icon: 'users',
    data: [Permissions.Mqs_View],
    hidden: true,
    items: [
      {
        title: 'Dashboard',
        icon: 'chart-pie',
        link: ['/', 'app-reports', 'mqs', { id_2: '598037fb-416a-43ef-bdc7-f2943fcd235c' }],
        data: [Permissions.Mqs_Reports],
        disableHighlight: true,
      },
      {
        title: 'Worklist',
        icon: 'list-alt',
        link: '/mqs/mqs',
        data: [Permissions.Mqs_View
        ],
      },
      {
        title: 'My Assignments',
        icon: 'tasks',
        link: '/mqs/assignments',
        data: [Permissions.Mqs_View],
      },
      {
        title: 'Outstanding Customer Surveys',
        icon: 'bookmark',
        link: '/mqs/surveys',
        data: [Permissions.Mqs_CustomerSurvey],
      },
      {
        title: 'Customers',
        icon: 'globe',
        link: '/mqs/customers',
        data: [Permissions.Mqs_View],
      },
      {
        title: 'Contacts',
        icon: 'phone',
        link: '/mqs/contacts',
        data: [Permissions.Mqs_View],
      },
      {
        title: 'Leads',
        icon: 'book',
        link: '/mqs/leads',
        data: [Permissions.Mqs_View],
      },
      {
        title: 'Quote Progress',
        icon: 'spinner',
        link: '/mqs/bulkenquiries',
        data: [Permissions.Mqs_CreateLead, Permissions.Mqs_CreateQuoteEnquiry
        ],
      },
      {
        title: 'Job Cards Progress',
        icon: 'spinner',
        link: '/mqs/bulkjobcards',
        data: [Permissions.Mqs_ProjectProgress],
      },
      //{
      //  title: 'Leads',
      //  icon: 'users',
      //  link: '/mqs/leads',
      //  data: [Permissions.SuperAdmin],
      //},
      //{
      //  title: 'Quote Enquiries',
      //  icon: 'users',
      //  link: '/mqs/enquiries',
      //  data: [Permissions.SuperAdmin],
      //},
      //{
      //  title: 'Projects',
      //  icon: 'users',
      //  link: '/mqs/projects',
      //  data: [Permissions.SuperAdmin],
      //},
      //{
      //  title: 'Jobcards',
      //  icon: 'users',
      //  link: '/mqs/jobcards',
      //  data: [Permissions.SuperAdmin],
      //},
      {
        title: 'Reports',
        icon: 'cabinet-filing',
        link: '/app-reports/mqs',
        data: [Permissions.Mqs_Reports],
      },
      {
        title: 'Lookups',
        icon: 'cog',
        link: ['/', 'mqs', 'lookups', { appId: '36A0AD0F-EB87-4739-8843-DF21AF74CF26' }],
        data: [Permissions.Mqs_ManageLookups],
      },
      {
        title: 'Serial Register',
        icon: 'database',
        link: '/mqs/serialregister',
        data: [Permissions.Mqs_ViewSerialRegister],
      }
    ]
  },
  {
    groupName: 'Employee / Candidate Database',
    icon: 'users',
    data: [Permissions.SPS_Admin,
    Permissions.SPS_Edit,
    Permissions.SPS_Lookups,
    Permissions.SPS_View],
    hidden: true,
    items: [
      {
        title: 'Employees / Candidates',
        icon: 'users',
        link: '/sps/personnel',
        data: [Permissions.SPS_Admin,
        Permissions.SPS_Edit,
        Permissions.SPS_View],
      },

      {
        title: 'Bulk Placement',
        icon: 'inbox-out',
        link: '/sps/placement'
      },
      {
        title: 'Bulk Upload',
        icon: 'upload',
        link: '/sps/upload'
      },

      {
        title: 'Reports',
        icon: 'cabinet-filing',
        link: '/sps/reports',
        data: [Permissions.SPS_Admin,
        Permissions.SPS_Edit,
        Permissions.SPS_View],
      },
      {
        title: 'General Lookups',
        icon: 'cog',
        link: '/sps/lookups',
        data: [Permissions.SPS_Admin,
        Permissions.SPS_Lookups],
      },
      {
        title: 'PPE Sizes',
        icon: 'cog',
        link: '/sps/ppe-lookups',
        data: [Permissions.SPS_Admin,
        Permissions.SPS_Lookups],
      }
    ]
  },
  {
    groupName: 'Requisitions',
    icon: 'shopping-cart',
    data: [Permissions.RequisitionCreate,
      Permissions.ProcurementApproval,
      Permissions.RequisitionApproval,
      Permissions.StockRequisition,
      Permissions.CreateStoreRequisition,
      Permissions.LargeReqAdminApproval,
      Permissions.ProcurementBranchApprover,
      Permissions.ProcurementBranchAdmin,
      Permissions.ProcurementFMApproval,
      Permissions.ProcurementFDApproval,
      Permissions.ProcurementManager,
      Permissions.ProcurementOperationsDirector,
      Permissions.ProcurementNonJobApproval,
      Permissions.StoreReqApprover,
      Permissions.ProcurementAssistantFMApproval,
      Permissions.ProcurementApprovalOther,
      Permissions.ProcurementRentalApproval,
      Permissions.ViewAllApprovedProcurement],

    items: [
      {
        title: 'Global Dashboard',
        icon: 'chart-pie',
        link: ['/', 'app-reports', 'procurement', { id_2: 'f56b92ac-4d38-470d-8536-d7a343f74f15' }],
        data: [Permissions.ProcurementAdmin, Permissions.SiteAdmin],

      },
      {
        title: 'Division Dashboard',
        icon: 'chart-pie',
        link: ['/', 'app-reports', 'procurement', { id_2: 'e5fac4b2-3739-49d8-ae65-a771f63c1e1a' }],
        data: [Permissions.ProcurementApproval, Permissions.SiteAdmin],

      },
      {
        title: 'Reports',
        icon: 'chart-line',
        link: '/app-reports/procurement',
        data: [Permissions.ProcurementApproval, Permissions.OutstandingItemsReport, Permissions.RequisitionCreate, Permissions.StockRequisition, Permissions.SiteAdmin],
      },
      {
        title: 'Requisition list',
        icon: 'shopping-cart',
        link: 'requisition/index',
        data: [
          Permissions.RequisitionCreate,
          Permissions.ProcurementApproval,
          Permissions.RequisitionApproval,
          Permissions.StockRequisition,
          Permissions.CreateStoreRequisition,
          Permissions.LargeReqAdminApproval,
          Permissions.ProcurementBranchApprover,
          Permissions.ProcurementBranchAdmin,
          Permissions.ProcurementFMApproval,
          Permissions.ProcurementFDApproval,
          Permissions.ProcurementManager,
          Permissions.ProcurementOperationsDirector,
          Permissions.ProcurementNonJobApproval,
          Permissions.StoreReqApprover,
          Permissions.ProcurementAssistantFMApproval,
          Permissions.ProcurementApprovalOther,
          Permissions.ProcurementRentalApproval,
          Permissions.ViewAllApprovedProcurement
        ]

      },
      {
        title: 'PO list',
        icon: 'shopping-cart',
        link: 'requisition/po',
        data: [
          Permissions.RequisitionCreate,
          Permissions.ProcurementApproval,
          Permissions.RequisitionApproval,
          Permissions.StockRequisition,
          Permissions.CreateStoreRequisition,
          Permissions.LargeReqAdminApproval,
          Permissions.ProcurementBranchApprover,
          Permissions.ProcurementBranchAdmin,
          Permissions.ProcurementFMApproval,
          Permissions.ProcurementFDApproval,
          Permissions.ProcurementManager,
          Permissions.ProcurementOperationsDirector,
          Permissions.ProcurementNonJobApproval,
          Permissions.StoreReqApprover,
          Permissions.ProcurementAssistantFMApproval,
          Permissions.ProcurementApprovalOther,
          Permissions.ProcurementRentalApproval,
          Permissions.ViewAllApprovedProcurement]

      },
      {
        title: 'Assets',
        icon: 'shopping-cart',
        link: 'requisition/assets',
        data: [Permissions.SuperAdmin]

      }


    ]
  },
  {
    groupName: 'KPI',
    icon: 'chart-line',
    data: [Permissions.Kpi_Capture, Permissions.Kpi_Reports, Permissions.Kpi_Admin],
    items: [

      {
        title: 'Dashboard',
        icon: 'chart-pie',
        link: '/kpi/dashboard',
        data: [Permissions.Kpi_Reports, Permissions.Kpi_Admin],
      },
      {
        title: 'Reports',
        icon: 'cabinet-filing',
        link: '/kpi/reports',
        data: [Permissions.Kpi_Reports, Permissions.Kpi_Admin],
      },
      {
        title: 'Data Entry',
        icon: 'pencil',
        link: '/kpi/index',
        data: [Permissions.Kpi_Capture, Permissions.Kpi_Admin],

      },
      {
        title: 'Lookups',
        icon: 'cog',
        link: ['/', 'kpi', 'lookups', { appId: 'DB53D97E-EA05-42F3-B4E3-B65EFD1D3BCC' }],
        data: [Permissions.Kpi_Admin],
      },
      {
        title: 'Targets',
        icon: 'cog',
        link: ['/', 'kpi', 'config', { id_0: '00000000-0000-0000-0000-000000000000' }],
        data: [Permissions.Kpi_Admin],
      }

    ]
  },
  {
    groupName: 'Sales Reports',
    icon: 'chart-line',
    data: [Permissions.SalesDashboard, Permissions.SalesDashboardConfig],
    items: [

      {
        title: 'Dashboard',
        icon: 'chart-pie',
        link: '/sales-reports/dashboard',
        data: [Permissions.SalesDashboard],
      },
      {
        title: 'Setup',
        icon: 'cog',
        link: '/sales-reports/budgets',
        data: [Permissions.SalesDashboardConfig],
      }, {
        title: 'Branches',
        icon: 'cog',
        link: '/sales-reports/branches',
        data: [Permissions.SuperAdmin],
      }, {
        title: 'Product Classes',
        icon: 'cog',
        link: '/sales-reports/product-class',
        data: [Permissions.SuperAdmin],
      }, {
        title: 'Holidays',
        icon: 'cog',
        link: '/sales-reports/holidays',
        data: [Permissions.SuperAdmin],
      },
    ]
  },
  {
    groupName: 'Data Management',
    icon: 'store-alt',
    link: 'secondaryUrl/stock/list',
    data: [Permissions.StockItemsModule, Permissions.StockItemsModuleView, Permissions.SupplierEdit, Permissions.SupplierManageDocuments, Permissions.ViewCreditors, Permissions.EditCreditors, Permissions.StockItemsModuleEdit, Permissions.StockItemsModuleView],

    items: [
      {
        title: 'Catalog',
        icon: 'box-open',
        link: 'secondaryUrl/stock/list',
        data: [Permissions.StockItemsModuleView, Permissions.StockItemsModuleEdit],
      },
      {
        title: 'Suppliers',
        icon: 'building',
        link: 'stock/supplier',
        data: [Permissions.SupplierEdit, Permissions.SupplierManageDocuments],

      },
      {
        title: 'Creditors',
        icon: 'building',
        link: 'stock/creditors',
        data: [Permissions.ViewCreditors, Permissions.EditCreditors],
      },
      {
        title: 'Monthly Creditors Batch',
        icon: 'building',
        link: 'stock/creditorsBatch',
        data: [Permissions.ViewCreditors, Permissions.EditCreditors],

      },
      {
        title: 'Stock Items',
        icon: 'box-open',
        link: 'stock/items',
        data: [Permissions.StockItemsModuleEdit],

      }
    ]

  },
  {
    groupName: 'Invoicing',
    icon: 'file-invoice-dollar',
    link: 'secondaryUrl/stock/list',
    data: [Permissions.InvoicingModule, Permissions.InvoicingEdit, Permissions.InvoiceViewPermission],

    items: [
      {
        title: 'View Invoices',
        icon: 'file-invoice-dollar',
        link: 'secondaryUrl/invoicing/index',
        data: [Permissions.InvoicingModule, Permissions.InvoicingEdit, Permissions.InvoiceViewPermission]
      },
      {
        title: 'Reports',
        icon: 'cabinet-filing',
        link: '/app-reports/invoicing',
        data: [Permissions.InvoicingReports],
      },

    ]

  },


  {
    groupName: 'Imports',
    icon: 'upload',
    link: 'secondaryUrl/pages/ui-features',
    expanded: false,
    data: [Permissions.ImportsModule],

    items: [
      {
        title: 'Stock Items',
        icon: 'upload',
        link: 'secondaryUrl/import/stock'
      }, {
        title: 'Suppliers',
        icon: 'upload',
        link: 'secondaryUrl/import/supplier'
      },

    ]
  },
  {
    groupName: 'Admin',
    icon: 'lock',
    link: 'secondaryUrl/pages/ui-features',
    expanded: false,
    data: [Permissions.SuperAdmin, Permissions.OrganisationManage, Permissions.SiteAdmin, Permissions.ContractManagerAdministration],

    items: [{
      title: 'General Ledgers',
      icon: 'users',
      link: 'hr/ledgers',

      data: [Permissions.SuperAdmin, Permissions.OrganisationManage, Permissions.SiteAdmin]
    },
    {
      title: 'Users',
      icon: 'users',
      link: 'hr/users',

      data: [Permissions.SuperAdmin, Permissions.OrganisationManage, Permissions.SiteAdmin]
    }, {
      title: 'Organisations',
      link: 'hr/organisations',
      icon: 'building',

      data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
    }, {
      title: 'Branches',
      link: 'hr/branches',
      icon: 'code-branch',

      data: [Permissions.SuperAdmin]
    }, {
      title: 'Jobs',
      link: 'hr/jobs',
      icon: 'location-arrow',

      data: [Permissions.SuperAdmin, Permissions.SiteAdmin, Permissions.ContractManagerAdministration]
      },
      {
        title: 'Contract Managers',
        link: 'hr/contractmanagers',
        icon: 'user',

        data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
      },
      
      {
      title: 'Sites',
      link: 'hr/sites',
      icon: 'thumbtack',

      data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
    },
    {
      title: 'Global Roles',
      link: 'hr/roles',
      icon: 'user-shield',

      data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
    },
    {
      title: 'User Import',
      link: 'secondaryUrl/hr/userimport',
      icon: 'upload',

      data: [Permissions.SuperAdmin]
    }
      ,
    {
      title: 'Mailboxes',
      link: 'hr/mailbox',
      icon: 'mail-bulk',

      data: [Permissions.SuperAdmin]
    }, {
      title: 'User Groups',
      icon: 'users',
      link: 'hr/userGroups',

      data: [Permissions.SuperAdmin, Permissions.OrganisationManage, Permissions.SiteAdmin]
    },
    {
      title: 'Catalogue Items',
      icon: 'users',
      link: 'catalogue/index',

      data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
    },
    {
      title: 'Warehouses',
      icon: 'users',
      link: 'hr/warehouses',

      data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
    },
    {
      title: 'Workflows',
      icon: 'users',
      link: 'hr/workflows',

      data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
    },
    {
      title: 'Transitions',
      icon: 'users',
      link: 'hr/transitions',

      data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
    },
    ]
  },
  {
    groupName: 'Transitions',
    icon: 'lock',
    link: 'hr/transitions',
    expanded: false,
    data: [Permissions.SuperAdmin],

    items: [
      {
        title: 'Templates',
        icon: 'users',
        link: 'hr/transitions',

        data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
      }, {
        title: 'Actions',
        icon: 'users',
        link: 'hr/transitionsactions',

        data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
      },
      {
        title: 'Requirements',
        icon: 'users',
        link: 'hr/transitionsrequirements',

        data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
      },
      {
        title: 'Validations',
        icon: 'users',
        link: 'hr/transitionsvalidations',

        data: [Permissions.SuperAdmin, Permissions.SiteAdmin]
      },
    ]
  },
  {
    groupName: 'Report Builder',
    icon: 'lock',
    link: 'secondaryUrl/pages/ui-features',
    expanded: false,
    data: [Permissions.SuperAdmin],

    items: [
      {
        title: 'Reports',
        icon: 'file-chart-pie',
        link: '/reports/builder',
        //permissions: [{ permissions: [{ permission: PermissionList.SuperAdmin, rights: PermissionRights.Manage }] }],
      },
      {
        title: 'Report Config',
        icon: 'cogs',
        link: '/reports/builderconfig',
        //permissions: [{ permissions: [{ permission: PermissionList.SuperAdmin, rights: PermissionRights.Manage }] }],
      }
    ]
  },
  {
    groupName: 'Reports',
    icon: 'lock',
    link: 'secondaryUrl/pages/ui-features',
    expanded: false,
    data: [Permissions.SuperAdmin],

    items: [
      {
        title: 'Reports',
        icon: 'file-chart-pie',
        link: '/reports/index',
        //permissions: [{ permissions: [{ permission: PermissionList.SuperAdmin, rights: PermissionRights.Manage }] }],
      }
    ]
  },
  {
    groupName: 'Modules Visited',
    icon: 'users',
    data: [Permissions.UserModulesVisited, Permissions.SuperAdmin],
    items: [
      {
        title: 'List',
        icon: 'users',
        link: 'usermodulesvisited/index',
        data: [
          Permissions.UserModulesVisited, Permissions.SuperAdmin
        ]
      }
    ]
  },
  {
    title: 'My Profile',
    icon: 'user',
    link: 'secondaryUrl/party/profile'
  },
  {
    groupName: 'JCE',
    icon: 'file-invoice-dollar',
    data: [Permissions.JSEModule],

    items: [
      {
        title: 'Work Orders',
        icon: 'file-invoice-dollar',
        link: 'secondaryUrl/jse/workorders',
        data: [Permissions.JSEModule],
      },
      {
        title: 'Invoices',
        icon: 'file-invoice-dollar',
        link: 'secondaryUrl/jse/invoices',
        data: [Permissions.JSEModule],
      },
      {
        title: 'Scaffoling Register',
        icon: 'file-invoice-dollar',
        link: 'secondaryUrl/jse/scaffolding',
        data: [Permissions.JSEModule],
      },
      {
        title: 'Reports',
        icon: 'file-invoice-dollar',
        link: 'secondaryUrl/jse/reports',
        data: [Permissions.JSEModule],
      },

    ]

  },
  {
    groupName: 'Scaffolding Requisitions',
    icon: 'th',
    data: [Permissions.ScaffoldMaterialRequestAdmin, Permissions.ScaffoldMaterialRequestOfficer, Permissions.ScaffoldMaterialRequestor, Permissions.ScaffoldMaterialRequestApprover, Permissions.ScaffoldMaterialRequestReports],

    items: [
      {
        title: 'Requests',
        icon: 'th',
        link: '/scaffolding-material/requests',
        data: [Permissions.ScaffoldMaterialRequestAdmin, Permissions.ScaffoldMaterialRequestOfficer, Permissions.ScaffoldMaterialRequestor, Permissions.ScaffoldMaterialRequestApprover],
      },
      {
        title: 'Reports',
        icon: 'chart-line',
        link: '/scaffolding-material/reports',
        data: [Permissions.ScaffoldMaterialRequestReports],
      },


    ]

  },


  {
    title: 'Detailed WIP Report',
    icon: 'file-invoice-dollar',
    link: 'secondaryUrl/detailedwip/index',
    expanded: false,
    data: [Permissions.ViewDetailedWIPReport]
  },
  //{
  //  title: 'IMS',
  //  icon: 'folder',
  //  link: 'secondaryUrl/ims/index',
  //  permissions:
  //    [{ permissions: [{ permission: Permissions.ImsModule }] },
  //    { permissions: [{ permission: Permissions.EMSView }] }, {
  //    permissions: [{ permission: Permissions.EMSManage }]
  //  }]

  //},
  //{
  //  groupName: 'Requisitions',
  //  icon: 'shopping-cart',
  //  permissions: [{ permissions: [{ permission: Permissions.RequisitionApproval }] }, {
  //    permissions: [{ permission: Permissions.RequisitionCreate }]
  //  }, {
  //    permissions: [{ permission: Permissions.StockRequisition }]
  //  },
  //  {
  //    permissions: [{ permission: Permissions.ProcurementApproval }]
  //  }, {
  //    permissions: [{ permission: Permissions.RequisitionJobManagement }]
  //  }],

  //  items: [
  //    {
  //      title: 'How it works',
  //      icon: 'info',
  //      link: '/requisition/tutorial',
  //    },
  //    {
  //      title: 'Dashboard',
  //      icon: 'chart-pie',
  //      link: '/reqdashboard/index',
  //      permissions: [{ permissions: [{ permission: Permissions.ProcurementApproval }] }],

  //    },
  //    {
  //      title: 'Reports',
  //      icon: 'chart-line',
  //      link: '/reqreports/index',
  //      permissions: [{ permissions: [{ permission: Permissions.ProcurementApproval }] }, {
  //        permissions: [{ permission: Permissions.OutstandingItemsReport }]
  //      }],

  //    },
  //    {
  //      title: 'Requisition list',
  //      icon: 'shopping-cart',
  //      link: '/requisition/index',
  //      permissions: [{ permissions: [{ permission: Permissions.RequisitionApproval }] }, {
  //        permissions: [{ permission: Permissions.RequisitionCreate }]
  //      }, {
  //        permissions: [{ permission: Permissions.StockRequisition }]
  //      },
  //      {
  //        permissions: [{ permission: Permissions.ProcurementApproval }]
  //      }],
  //    }

  //  ]
  //},
  //{
  //  groupName: 'Stock Management',
  //  icon: 'store-alt',
  //  link: '/stock/list',
  //  permissions: [{ permissions: [{ permission: Permissions.StockItemsModule }] }, {
  //    permissions: [{ permission: Permissions.StockItemsModuleView }]
  //  }, {
  //      permissions: [{ permission: Permissions.SupplierEdit }]
  //  }, {
  //      permissions: [{ permission:Permissions.SupplierManageDocuments }]
  //  }],

  //  items: [
  //    {
  //      title: 'Catalog',
  //      icon: 'box-open',
  //      link: '/stock/list',
  //      permissions: [{ permissions: [{ permission: Permissions.StockItemsModuleView }] }, {
  //        permissions: [{ permission: Permissions.StockItemsModuleEdit }]
  //      }],
  //    },
  //    {
  //      title: 'Suppliers',
  //      icon: 'building',
  //      link: '/stock/supplier',
  //      permissions: [{ permissions: [{ permission: Permissions.SupplierEdit }] }, {
  //        permissions: [{ permission: Permissions.SupplierManageDocuments }]
  //      }],

  //    }
  //  ]

  //},
  //{
  //  groupName: 'Invoicing',
  //  icon: 'file-invoice-dollar',
  //  link: '/stock/list',
  //  permissions: [{ permissions: [{ permission: Permissions.InvoicingModule }] }, {
  //    permissions: [{ permission:Permissions.InvoicingEdit }]
  //  }],

  //  items: [
  //    {
  //      title: 'View Invoices',
  //      icon: 'file-invoice-dollar',
  //      link: '/invoicing/index',
  //      permissions: [{ permissions: [{ permission: Permissions.InvoicingModule }] }, {
  //        permissions: [{ permission: Permissions.InvoicingEdit }]
  //      }],
  //    }
  //  ]

  //},


  //{
  //  groupName: 'Imports',
  //  icon: 'upload',
  //  link: '/pages/ui-features',
  //  expanded: false,
  //  permissions: [{ permissions: [{ permission: Permissions.ImportsModule }] }],

  //  items: [
  //    {
  //      title: 'Stock Items',
  //      icon: 'upload',
  //      link: '/import/stock'
  //    }, {
  //      title: 'Suppliers',
  //      icon: 'upload',
  //      link: '/import/supplier'
  //    },

  //  ]
  //},
  {
    groupName: 'Tender Register',
    icon: 'lock',
    expanded: false,
    data: [Permissions.TenderRegister, Permissions.SuperAdmin],
    items: [
      {
        title: 'Tenders',
        icon: 'users',
        link: '/tender/tenders',
        data: [Permissions.TenderRegister, Permissions.SuperAdmin],


      },
      {
        title: 'Scopes',
        icon: 'users',
        link: '/tender/scopes',
        data: [Permissions.TenderRegister, Permissions.SuperAdmin],
      },
      {
        title: 'Reports & Statistics',
        icon: 'chart-pie',
        link: '/tender/dynamicreports',
        data: [Permissions.TenderRegisterReports, Permissions.SuperAdmin],
      },
    ]
  },
  //{
  //  groupName: 'Admin',
  //  icon: 'lock',
  //  link: '/pages/ui-features',
  //  expanded: false,
  //  permissions: [{ permissions: [{ permission: Permissions.SuperAdmin }] }, {
  //    permissions: [{ permission: Permissions.OrganisationManage }]
  //  }],

  //  items: [
  //    {
  //      title: 'Users',
  //      icon: 'users',
  //      link: '/hr/users',

  //      permissions: [{ permissions: [{ permission: Permissions.SuperAdmin }] }, {
  //        permissions: [{ permission: Permissions.OrganisationManage }]
  //      }]
  //    }, {
  //      title: 'Organisations',
  //      link: '/hr/organisations',
  //      icon: 'building',

  //      permissions: [{ permissions: [{ permission: Permissions.SuperAdmin }] }]
  //    }, {
  //      title: 'Global Roles',
  //      link: '/hr/roles',
  //      icon: 'user-shield',

  //      permissions: [{ permissions: [{ permission: Permissions.SuperAdmin }] }]
  //    },
  //    {
  //      title: 'User Import',
  //      link: '/hr/userimport',
  //      icon: 'upload',

  //      permissions: [{ permissions: [{ permission: Permissions.SuperAdmin }] }]
  //    },
  //    {
  //      title: 'Sites',
  //      link: '/hr/sites',
  //      icon: 'building',

  //      permissions: [{ permissions: [{ permission: Permissions.SuperAdmin }] }]
  //    },


  //  ]
  //}
  //{
  //  title: 'My Profile',
  //  icon: 'user',
  //  link: '/party/profile',
  //  expanded: false
  //},
  //{
  //  groupName: 'JCE',
  //  icon: 'file-invoice-dollar',
  //  permissions: [{ permissions: [{ permission: Permissions.JSEModule }] }],

  //  items: [
  //    {
  //      title: 'Work Orders',
  //      icon: 'file-invoice-dollar',
  //      link: '/jse/workorders',
  //      permissions: [{ permissions: [{ permission: Permissions.JSEModule }] }],
  //    },
  //    {
  //      title: 'Invoices',
  //      icon: 'file-invoice-dollar',
  //      link: '/jse/invoices',
  //      permissions: [{ permissions: [{ permission: Permissions.JSEModule }] }],
  //    },
  //    {
  //      title: 'Scaffoling Register',
  //      icon: 'file-invoice-dollar',
  //      link: '/jse/scaffolding',
  //      permissions: [{ permissions: [{ permission: Permissions.JSEModule }] }],
  //    },
  //    {
  //      title: 'Reports',
  //      icon: 'file-invoice-dollar',
  //      link: '/jse/reports',
  //      permissions: [{
  //        permissions: [{ permission: Permissions.JSEModule }]
  //      }],
  //    },

  //  ]

  //},
  //{
  //  title: 'Detailed WIP Report',
  //  icon: 'file-invoice-dollar',
  //  link: '/detailedwip/index',
  //  expanded: false,
  //  permissions: [{ permissions: [{ permission: Permissions.ViewDetailedWIPReport }] }]
  //}
];
